import { useNavigate } from "react-router-dom"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { ModalId, useUIActions } from "../../../../../features/ui"
import { useHoardService } from "../../../services/hoardService"

export const useActions = () => {
    const { getRoutePath } = useRoutesHooks()
    const { increaseHoardValue } = useHoardService()
    const { closeModal } = useUIActions()
    const navigate = useNavigate()

    const submitIncreaseHoard = async (
        hoardId: string,
        addedAmount: number,
        isCreditAccount: boolean
    ) => {
        const hoardPath = getRoutePath(RoutePath.HOARDS, hoardId)
        if (isCreditAccount) {
            // En cuenta corriente no hay cobro: la ampliación se guarda ahora y la deuda queda en la cuenta del cliente
            await increaseHoardValue(hoardId, addedAmount)
            Emitter.emit(Event.DB_SUBMIT_DONE, false, false, hoardPath)
        } else {
            // La ampliación se guarda recién al confirmar el cobro: si se cancela, no queda registrada
            navigate(`${hoardPath}/${RoutePath.CONFIRM_PAYMENT}`, { state: { increaseAmount: addedAmount } })
            // El formulario abre el spinner al enviar; mientras se está abriendo Bootstrap ignora el cierre,
            // así que se cierra cuando terminó de abrir (como en onDbSubmitDone)
            setTimeout(() => closeModal(ModalId.SPINNER), 500)
        }
    }

    return {
        submitIncreaseHoard
    }
}
